class ConfiguratorToppers {
    constructor() {
        this.id = 'toppers';
        this.cache = {};
        this.items = {};
        this.buyables = {};

        this.selectors = [
            'toppers'
        ];

        this.sizes = bed_configuration.sizes;

        //configurator.initSelector(this);
        configurator.addSelectorItem(this.id);
    }

    isValidSelector(selector) {
        return this.selectors.includes(selector);
    }

    setupListeners() {
    }

    async refresh(selector) {
        if (configurator.selection.size == null || configurator.selection.fabric == null) {
            configurator.resetSelector( this.id );
            return;
        }

        /*if (init_configurators.includes('boxsprings') &&
                configurator.selection.boxsprings == null && configurator.selection.toppers != null) {
                    configurator.resetSelector('toppers');
        }*/

        if (!(configurator.selection.size in this.cache) || !(configurator.selection.fabric in this.cache[configurator.selection.size])) {
            await this.loadItems(configurator.selection.size, configurator.selection.fabric);
        }

        this.populateItems();
    }

    async loadItems(size, fabric) {
        const size_arr = size.split('x');
        let width = parseInt(size_arr[0]);
        const is_double = width > 140 ? true : false;

        // Check if already loaded
        if (size in this.cache && fabric in this.cache[size]) {
            return;
        }

        // Init data object
        if (!(size in this.cache)) {
            this.cache[size] = { 'title': size, 'fabrics': {}, 'products': {} };
        }
        this.cache[size]['fabrics'][fabric] = { 'title': fabric, 'products': {} };

        // Load Toppers without fabric
        const products_plain = await configurator.loadProductData('configurator-'+this.id+'-no-fabric', [], [], true);

        // Load Toppers with fabric
        const products_with_fabric = await configurator.loadProductData('configurator-mattress-toppers', [
            {key: 'size', value: size},
            {key: 'fabric', value: fabric},
        ], []);

        // Populate items
        for (const product of products_plain) {
            if (bed_configuration.is_adjustable != product.productid.includes('split') && is_double) { continue; }

            for (const variant of product.variants) {
                if (variant.option1 != size) { continue; }

                // Skip variants with price 0 when e-commerce is enabled
                if (variant.price == 0 && configurator.enable_ecommerce == true) { continue; }

                // Skip if SKU is globally excluded
                if (bed_configuration.excluded_skus_global_set && bed_configuration.excluded_skus_global_set.has(variant.sku)) {
                    console.log(`Topper SKU ${variant.sku} for product ${product.productid} (plain) excluded globally.`);
                    continue;
                }

                // Build Cylindo thumbnail URL
                if (product.cylindo_model != null) {
                    variant.featured_image = {'src': this.getCylindoThumbnail(product)};
                }

                // Add to data array
                this.cache[size]['products'][product.productid] = configurator.variantToItem(product, variant);
            }
        }

        for (const product of products_with_fabric) {
            if (bed_configuration.is_adjustable != product.productid.includes('split') && is_double) { continue; }

            // Skip products with price 0 when e-commerce is enabled
            if (product.variants[0].price == 0 && configurator.enable_ecommerce == true) { continue; }

            // Skip if the primary variant's SKU is globally excluded
            if (bed_configuration.excluded_skus_global_set && bed_configuration.excluded_skus_global_set.has(product.variants[0].sku)) {
                console.log(`Topper SKU ${product.variants[0].sku} for product ${product.productid} (with fabric) excluded globally.`);
                continue;
            }

            // Find Reference Product parent
            configurator.applyReferenceProduct(product);

            // Build Cylindo thumbnail URL
            if (product.cylindo_model != null) {
                product.image = this.getCylindoThumbnail(product);
            }

            // Add to data array
            this.cache[size]['fabrics'][fabric]['products'][product.productid] = configurator.productToItem(product);
        }

        if (bed_configuration.is_adjustable == true && is_double) {
            const x2_size = is_double && bed_configuration.split_base ? (size_arr[0] / 2) + 'x' + size_arr[1] : null;

            // Load Toppers with fabric
            const products_with_fabric_x2 = await configurator.loadProductData('configurator-mattress-toppers', [
                {key: 'size', value: x2_size},
                {key: 'fabric', value: fabric},
            ], ['size']);

            for (const product of products_plain) {
                for (const variant of product.variants) {
                    if (variant.option1 != x2_size) { continue; }

                    // Skip variants with price 0 when e-commerce is enabled
                    if (variant.price == 0 && configurator.enable_ecommerce == true) { continue; }

                    // Skip if SKU is globally excluded
                    if (bed_configuration.excluded_skus_global_set && bed_configuration.excluded_skus_global_set.has(variant.sku)) {
                        console.log(`Topper SKU ${variant.sku} for product ${product.productid} (plain, x2) excluded globally.`);
                        continue;
                    }

                    // Add to data array
                    product.handle = '2x'+product.handle;
                    product.productid = '2x'+product.productid;
                    const item = configurator.variantToItem(product, variant);
                    item.label = '2 x '+item.label;
                    item.ids = [...item.ids, ...item.ids];
                    item.skus = [...item.skus, ...item.skus];
                    item.price = 2 * item.price;

                    // Build Cylindo thumbnail URL
                    if (product.cylindo_model != null) {
                        item.thumbnail = this.getCylindoThumbnail(product);
                    }

                    this.cache[size]['products'][product.productid] = item;
                }
            }

            for (const product of products_with_fabric_x2) {
                if (product.size != x2_size) { continue; }

                // Skip products with price 0 when e-commerce is enabled
                if (product.variants[0].price == 0 && configurator.enable_ecommerce == true) { continue; }

                // Skip if the primary variant's SKU is globally excluded
                if (bed_configuration.excluded_skus_global_set && bed_configuration.excluded_skus_global_set.has(product.variants[0].sku)) {
                    console.log(`Topper SKU ${product.variants[0].sku} for product ${product.productid} (with fabric, x2) excluded globally.`);
                    continue;
                }

                // Find Reference Product parent
                configurator.applyReferenceProduct(product);

                // Add to data array
                product.handle = '2x'+product.handle;
                product.productid = '2x'+product.productid;
                const item = configurator.productToItem(product);
                item.label = '2 x '+item.label;
                item.ids = [...item.ids, ...item.ids];
                item.skus = [...item.skus, ...item.skus];
                item.price = 2 * item.price;

                // Build Cylindo thumbnail URL
                if (product.cylindo_model != null) {
                    item.thumbnail = this.getCylindoThumbnail(product);
                }

                this.cache[size]['fabrics'][fabric]['products'][product.productid] = item;
            }
        }
    }

    populateItems() {
        let sel_size = configurator.selection.size;

        if ('boxsprings' in configurator.selector_objects && !configurator.selection.boxsprings) {
            configurator.resetSelectorData('toppers');
            return;
        }

        this.items = {
            ...this.cache[sel_size]['fabrics'][configurator.selection.fabric]['products'],
            ...this.cache[sel_size]['products']
        };
        configurator.renderSelector(this.id, Object.values(this.items), {
            'thumbnails': true,
        });
    }

    isSoldOut() {
        const item = this.items[ configurator.selection.toppers ];

        if (item && item.available) return false;
        return true;
    }

    getPriceData(priceData) {
        const item = this.items[ configurator.selection.toppers ];
        if (item != null) {
            priceData.total += item.price ?? 0;
            priceData.skus.push(...item.skus);
            priceData.ids.push(...item.ids);
        }
    }

    getCylindoSpecs(specs) {
        // ============== Translate Topper config ==============
        const sel = configurator.selection.toppers;
        if (sel == null) {
            specs.features['TOP MATTRESS'] = 'OFF';
            return;
        }

        // Regular mapping logic for selected toppers
        if (sel.includes('luxury')) specs.features['TOP MATTRESS'] = 'LUXURY';
        else if (sel.includes('premium')) specs.features['TOP MATTRESS'] = 'PREMIUM';
        else if (sel.includes('prestige')) specs.features['TOP MATTRESS'] = 'PRESTIGE';

        if (sel.includes('2x')) {
            specs.features['TOP MATTRESS'] += ' 2x90';
        }
    }

    getCylindoThumbnail(product) {
        if (product.handle.includes('2x')) {
            product.cylindo_model += ' 2x90';
        }

        let base_url = bed_configuration.cylindo_base_url + product.cylindo_model + '/frames/3/' + product.cylindo_model + '.jpg?'
            + 'size=512&background=f7f7f7&encoding=jpg';

        if (!(product.handle.includes('split')) && !(product.handle.includes('2x'))) {
            // Apply size to thumbnail
            const size_arr = configurator.selection.size.split('x');

            let model_size = '180';
            if (['80', '90', '105'].includes(size_arr[0])) { model_size = '90'; }
            if (['120', '135', '140', '150'].includes(size_arr[0])) { model_size = '140'; }
            if (['160', '180', '200', '210'].includes(size_arr[0])) { model_size = '180'; }

            base_url += `&feature=SIZE:200x${model_size}`;
        }

        if (product.handle.includes('luxury')) {
            const cylindo_fabric = configurator.m3_fabrics[configurator.selection.fabric][0];
            base_url += `&feature=UPHOLSTERY:${cylindo_fabric}`;
        }

        return base_url;
    }
}
